import React, { useState } from "react";
import { Mail, Phone, MapPin, Home, Hammer, Calendar, X } from "lucide-react";

function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch { return iso; }
}

const intentLabel = { buy: "Buy + Renovate", own: "Renovate Own Home" };

export default function LeadsTable({ leads }) {
  const [active, setActive] = useState(null);

  if (!leads.length) {
    return (
      <div className="text-center py-24 bg-white border border-cream-dark">
        <p className="font-serif text-2xl text-navy">No leads yet</p>
        <p className="font-sans text-charcoal/60 mt-2">New project inquiries from your website will appear here.</p>
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-cream-dark overflow-x-auto">
        <table className="w-full min-w-[720px]">
          <thead>
            <tr className="border-b border-cream-dark bg-cream/60">
              {["Name", "Contact", "Starting Point", "Project", "Budget", "Received"].map((h) => (
                <th key={h} className="text-left font-sans text-[10px] tracking-wide-nav uppercase text-charcoal/55 px-5 py-4">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {leads.map((l) => (
              <tr key={l.id} onClick={() => setActive(l)} className="border-b border-cream-dark last:border-0 hover:bg-cream/50 cursor-pointer transition-colors">
                <td className="px-5 py-4 font-serif text-lg text-navy">{l.name}</td>
                <td className="px-5 py-4 font-sans text-sm text-charcoal/75">{l.email}<br /><span className="text-charcoal/50">{l.phone || "—"}</span></td>
                <td className="px-5 py-4"><span className="inline-flex items-center gap-1.5 font-sans text-[11px] tracking-wide-nav uppercase text-gold border border-gold/40 px-2.5 py-1">{intentLabel[l.intent] || "—"}</span></td>
                <td className="px-5 py-4 font-sans text-sm text-charcoal/75">{l.projectType || "—"}</td>
                <td className="px-5 py-4 font-sans text-sm text-charcoal/75">{l.budget || "—"}</td>
                <td className="px-5 py-4 font-sans text-xs text-charcoal/55">{fmtDate(l.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {active && (
        <div className="fixed inset-0 z-[70] bg-navy/60 backdrop-blur-sm flex items-start justify-center overflow-y-auto py-10 px-4" onClick={() => setActive(null)}>
          <div className="bg-cream max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="bg-navy px-7 py-6 flex items-start justify-between">
              <div>
                <h3 className="font-serif text-3xl text-cream">{active.name}</h3>
                <p className="font-sans text-[11px] tracking-wide-nav uppercase text-gold-soft mt-1">{intentLabel[active.intent] || "Inquiry"}</p>
              </div>
              <button onClick={() => setActive(null)} className="text-cream/70 hover:text-gold"><X size={24} /></button>
            </div>
            <div className="p-7 space-y-4">
              <a href={`mailto:${active.email}`} className="flex items-center gap-3 text-navy hover:text-gold transition-colors"><Mail size={17} className="text-gold" /><span className="font-sans text-sm">{active.email}</span></a>
              <a href={`tel:${active.phone}`} className="flex items-center gap-3 text-navy hover:text-gold transition-colors"><Phone size={17} className="text-gold" /><span className="font-sans text-sm">{active.phone || "—"}</span></a>
              <div className="flex items-center gap-3 text-navy"><MapPin size={17} className="text-gold" /><span className="font-sans text-sm">Lives in {active.city || "—"} · Property: {active.location || "—"}</span></div>
              <div className="flex items-center gap-3 text-navy">{active.intent === "buy" ? <Home size={17} className="text-gold" /> : <Hammer size={17} className="text-gold" />}<span className="font-sans text-sm">{active.projectType || "—"} · {active.budget || "—"}</span></div>
              <div className="flex items-center gap-3 text-navy"><Calendar size={17} className="text-gold" /><span className="font-sans text-sm">Timeline: {active.timeline || "—"}</span></div>
              <div className="pt-4 border-t border-cream-dark">
                <p className="font-sans text-[11px] tracking-wide-nav uppercase text-charcoal/55 mb-2">Message</p>
                <p className="font-sans text-charcoal/80 leading-relaxed whitespace-pre-wrap">{active.message || "—"}</p>
              </div>
              <p className="font-sans text-xs text-charcoal/45 pt-2">Received {fmtDate(active.created_at)}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
